import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Check: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail2Check"><Path fillRule="evenodd" clipRule="evenodd" d="M22 9.11816L12 14.1182L4 10.1172V18H12V20H2V4H22V9.11816Z" fill="currentColor"/><Path d="M23.793 13.6094L18.1582 20.9336L14.3594 17.7686L15.6406 16.2314L17.8408 18.0654L22.207 12.3906L23.793 13.6094Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Check;
